import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";

import { IEmail } from "./email.interface";

export class EmailDelegate
{
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }

    public sendEmail(email: IEmail): Observable<boolean>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.EMAIL.SEND_EMAIL, email).pipe(
            map((response: any) =>
            {
                return response.data.success;
            }),
            share());
    }

}